<h3 class="mb-4">Register (Step 4 of 5)</h3>
<h4>Upload Document Front</h4>
<nz-upload
	nzType="drag"
	[nzCustomRequest]="customUpload"
	[nzBeforeUpload]="beforeUpload"
	(nzChange)="handleChange($event)"
    [nzShowUploadList]="false">
	<ng-container *ngIf="imagePreview; else iconTemplate">
		<img [src]="imagePreview" alt="preview" style="max-height: 150px; display: block; margin: auto;" />
	</ng-container>
	<ng-template #iconTemplate>
		<p class="ant-upload-drag-icon">
			<i nz-icon nzType="user"></i>
		</p>
	</ng-template>
</nz-upload>
<ngb-progressbar class="mb-3" [showValue]="true" type="info" [value]="uploadProgress" />
<button class="w-100 btn btn-primary" (click)="doNext()" [disabled]="!canGotoNext">Next</button>
